<template>

  <v-dialog v-model="s_geoReferenceOpen" max-width="500">
    <v-card>
      <v-card-title class="d-flex align-center">
        <v-icon color="primary" class="mr-2">mdi-cloud-upload</v-icon>
        画像アップロード
      </v-card-title>
      <v-card-text>
        <div>
          <v-text-field v-model="s_gazoName" placeholder="名称" variant="outlined"></v-text-field>
          <template v-if="isSmall500">
            <div v-if="isAndroid" class="native-select-wrapper">
              <label class="native-select-label" for="geo-zahyokei">選択してください</label>
              <select id="geo-zahyokei" v-model="s_zahyokei" class="native-select">
                <option v-for="item in zahyokeiItems" :key="item" :value="item">
                  {{ item }}
                </option>
              </select>
            </div>
            <v-select v-else
                      v-model="s_zahyokei"
                      :items="zahyokeiItems"
                      label="選択してください"
                      variant="outlined"
                      :menu-props="{
                        maxHeight: '350px',
                        overflow: 'scroll',
                        contentClass: 'scrollable-menu'
                      }"
            />
          </template>
          <v-select v-else
                    v-model="s_zahyokei"
                    :items="zahyokeiItems"
                    label="選択してください"
                    variant="outlined"
                    :menu-props="{
                      maxHeight: '350px',
                      overflow: 'scroll',
                      contentClass: 'scrollable-menu'
                    }"
          />

          <template v-if="isSmall500">
            <div v-if="isAndroid" class="native-select-wrapper">
              <label class="native-select-label" for="geo-transparent">透過方法を選択してください</label>
              <select id="geo-transparent" v-model="s_transparent" class="native-select">
                <option v-for="item in transparentItems" :key="item.value" :value="item.value">
                  {{ item.label }}
                </option>
              </select>
            </div>
            <v-select v-else
                      v-model="s_transparent"
                      :items="transparentItems"
                      item-title="label"
                      item-value="value"
                      label="透過方法を選択してください"
                      variant="outlined"
                      :menu-props="{
                        maxHeight: '350px',
                        overflow: 'scroll',
                        contentClass: 'scrollable-menu'
                      }"
            />
          </template>
          <v-select v-else
                    v-model="s_transparent"
                    :items="transparentItems"
                    item-title="label"
                    item-value="value"
                    label="透過方法を選択してください"
                    variant="outlined"
                    :menu-props="{
                      maxHeight: '350px',
                      overflow: 'scroll',
                      contentClass: 'scrollable-menu'
                    }"
          />
        </div>
        <v-btn @click="jpgLoad0">jpg読込開始</v-btn>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn variant="text" @click="s_geoReferenceOpen = false">閉じる</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>


  <v-dialog persistent v-model="s_watchPositionOpen" max-width="500">
    <v-card>
      <v-card-title class="d-flex align-center">
        <v-icon color="primary" class="mr-2">mdi-compass</v-icon>
        固定or回転
      </v-card-title>
      <v-card-text>
        <p class="oh3-mb-5">固定にすると北が上に固定されます。回転にするとスマホ時にスマホの向きに連動して地図が回転します。</p>
        <p class="oh3-mb-5 v-dialog-common-warning-text" v-if="s_isKuiuchi">「街区基準点」などのポイントをクリックしてください。その地点までの距離を計測します。（ポイント又はポリゴンの頂点をクリックできます。）</p>
        <v-btn class="oh3-ml-0" @click="$emit('watch-position','n')">固定</v-btn>
        <v-btn class="oh3-ml-2" @click="$emit('watch-position','h')">回転</v-btn>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn variant="text" @click="$emit('watch-position','close'); s_isKuiuchi = false">閉じる</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>



  <!-- バージョン通知 -->
  <v-dialog v-model="s_versionMessage" max-width="500">
    <v-card>
      <v-card-title class="d-flex align-center">
        <v-icon color="warning" class="mr-2">mdi-update</v-icon>
        バージョンが古くなっています。
      </v-card-title>
      <v-card-text>
        <p class="mb-4">アップデートしてください。現在のレイヤーを記憶したままアップデートします。</p>
        <v-btn @click="appUpdate">アップデート実行</v-btn>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn variant="text" @click="s_versionMessage=false">閉じる</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>

  <!-- 本体 -->
  <v-dialog v-model="s_fileDialogOpen" :max-width="isMobile ? 680 : 1080">
    <v-card class="pa-2">
      <!-- ヘッダー（アイコン＋ファイル名のみ） -->
      <div class="d-flex align-center justify-space-between px-3 py-2">
        <div class="d-flex align-center v-dialog-common-gap-10">
          <v-icon :color="iconColor" size="32">{{ iconName }}</v-icon>
          <div class="text-subtitle-1 ellipsis">{{ headerTitle }}</div>
        </div>
        <v-btn icon variant="text" @click="s_fileDialogOpen=false">
          <v-icon size="28">mdi-close</v-icon>
        </v-btn>
      </div>

      <v-card-text>
        <!-- ====== PDF ====== -->
        <div v-if="ext==='pdf'">
          <!-- 進行表示（青系） -->
          <div v-if="stage==='upload' || stage==='open' || stage==='warm'" class="statusBar mb-3">
            <div class="statusText">
              <template v-if="stage==='upload'">JPGに変換中…</template>
              <template v-else-if="stage==='open'">サーバーで準備中…</template>
              <template v-else>サムネ生成中… {{ thumbLoaded }} / {{ pdfPages }}</template>
            </div>
            <v-progress-linear
                color="primary"
                :indeterminate="stage!=='warm'"
                :model-value="stage==='warm' ? Math.round((thumbLoaded/(pdfPages||1))*100) : 0"
                height="6"
            />
          </div>

          <!-- コントロール -->
          <div class="d-flex align-center justify-space-between mb-2">
            <div class="d-flex align-center v-dialog-common-gap-8">
              <v-btn size="small" variant="tonal" :disabled="!pdfToken || pdfPage<=1" @click="stepPage(-1)">
                <v-icon>mdi-chevron-left</v-icon>
              </v-btn>

              <!-- ▼ 枠のみ & 低背 (約28px) & 小さめ文字 -->
              <v-text-field
                  v-model.number="pdfPage"
                  type="number"
                  min="1"
                  :max="pdfPages || 1"
                  variant="outlined"
                  density="compact"
                  hide-details
                  class="pageField v-dialog-common-page-field"
              />

              <v-btn size="small" variant="tonal" :disabled="!pdfToken || (pdfPages && pdfPage>=pdfPages)" @click="stepPage(1)">
                <v-icon>mdi-chevron-right</v-icon>
              </v-btn>
              <span class="text-caption text-medium-emphasis" v-if="pdfPages">/ 全{{ pdfPages }}ページ</span>
            </div>
            <div>
              <v-btn color="primary" size="small" :disabled="!pdfToken" :loading="pdfExporting" @click="toWarpWizard">
                <v-icon start>mdi-file-image</v-icon> このページをジオリファレンス
              </v-btn>
<!--              <v-btn color="primary" size="small" :disabled="!pdfToken" :loading="pdfExporting" @click="exportCurrentPage">-->
<!--                <v-icon start>mdi-file-image</v-icon> このページをJPEG化-->
<!--              </v-btn>-->
            </div>
          </div>

          <!-- 2カラム -->
          <div class="d-flex v-dialog-common-gap-16">
            <!-- 左：サムネ -->
            <div class="thumbColumn">
              <div class="thumbGrid">
                <div
                    v-for="i in pdfPages"
                    :key="'thumb-'+i"
                    class="thumbCard"
                    :class="[{ active: pdfPage===i }, i % 2 === 0 ? 'isEven' : 'isOdd']"
                    @click="selectPage(i)"
                    v-show="!thumbErrorMap[i]"
                >
                  <div class="thumbBadge">
                    <v-icon size="14">mdi-file-pdf-box</v-icon><span>{{ i }}</span>
                  </div>
                  <img
                      :src="thumbUrl(i)"
                      :alt="'p'+i"
                      class="thumbImg"
                      loading="lazy"
                      @load="onThumbLoad(i)"
                      @error="onThumbError(i)"
                  >
                  <!-- 目玉は削除。DLのみ -->
                  <div class="thumbHover">
                    <v-btn icon size="small" variant="text" title="このページをJPEG化" @click.stop="exportPage(i)">
                      <v-icon size="18">mdi-download</v-icon>
                    </v-btn>
                  </div>
                  <div class="thumbAccent" v-show="pdfPage===i"></div>
                </div>
              </div>
            </div>

            <!-- 右：プレビュー（fallbackテキスト無し） -->
            <div class="previewFrame">
              <div class="previewPane noScroll">
                <img
                    v-if="pdfToken"
                    :key="'preview-'+previewKey"
                    :src="currentPreviewSrc"
                    :alt="'preview-p'+pdfPage"
                    class="previewImg"
                    @load="onPreviewLoad"
                    @error="onPreviewError"
                >
                <!-- fallbackテキスト削除 -->

                <div v-show="pdfOpening || previewLoading" class="overlay">
                  <v-progress-circular indeterminate size="32" />
                </div>
              </div>
            </div>
          </div>

          <div v-if="pdfError" class="mt-2 text-error text-caption">{{ pdfError }}</div>
        </div>

        <!-- 画像（jpg/png） -->
        <div v-else-if="ext==='jpg' || ext==='jpeg' || ext==='png'">
          <div class="text-body-2 mb-2">画像プレビュー</div>
          <div class="d-flex flex-wrap v-dialog-common-gap-12">
            <div
                v-for="(url,i) in previewUrls"
                :key="'img-'+i"
                class="rounded-lg overflow-hidden v-dialog-common-image-wrapper"
            >
              <img :src="url" alt="preview" class="v-dialog-common-image-preview">
            </div>
          </div>
        </div>

        <!-- フォールバック -->
        <div v-else>
          <div class="text-medium-emphasis">この拡張子（{{ extUpper }}）のUIはまだ用意していません。</div>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState } from 'vuex'

const APIBASE = 'https://kenzkenz.net/myphp/pdf-service.php'

export default {
  name: 'VDialogCommon',
  emits: ['watchPosition'],
  computed: {
    ...mapState(['isSmall500', 'isAndroid']),
    s_isKuiuchi: {
      get(){ return this.$store.state.isKuiuchi },
      set(v){ this.$store.state.isKuiuchi = v }
    },
    s_transparent: {
      get(){ return this.$store.state.transparent },
      set(v){ this.$store.state.transparent = v }
    },
    s_zahyokei: {
      get(){ return this.$store.state.zahyokei },
      set(v){ this.$store.state.zahyokei = v }
    },
    s_gazoName: {
      get(){ return this.$store.state.gazoName },
      set(v){ this.$store.state.gazoName = v }
    },
    s_watchPositionOpen: {
      get(){ return this.$store.state.commonDialog.watchPositionOpen },
      set(v){ this.$store.state.commonDialog.watchPositionOpen = v }
    },
    s_geoReferenceOpen: {
      get(){ return this.$store.state.commonDialog.geoReferenceOpen },
      set(v){ this.$store.state.commonDialog.geoReferenceOpen = v }
    },
    s_versionMessage: {
      get(){ return this.$store.state.commonDialog.versionMessage },
      set(v){ this.$store.state.commonDialog.versionMessage = v }
    },
    s_fileDialogOpen: {
      get(){ return this.$store.state.commonDialog.fileDropOpen },
      set(v){ this.$store.state.commonDialog.fileDropOpen = v }
    },
    ext(){ return (this.$store.state.commonDialog.fileDropExt || '').toLowerCase() },
    files(){ return this.$store.state.commonDialog.fileDropFiles || [] },
    extUpper(){ return (this.ext || '').toUpperCase() },

    headerTitle(){
      if(this.ext==='pdf'){
        return this.pdfName || (this.files[0] && this.files[0].name) || 'PDF'
      }
      if(this.ext==='png' || this.ext==='jpg' || this.ext==='jpeg'){
        return (this.files[0] && this.files[0].name) || '画像'
      }
      return (this.files[0] && this.files[0].name) || 'ファイル'
    },

    iconName(){
      if(this.ext==='pdf') return 'mdi-file-pdf-box'
      if(this.ext==='png' || this.ext==='jpg' || this.ext==='jpeg') return 'mdi-file-image'
      return 'mdi-file'
    },
    iconColor(){
      if(this.ext==='pdf') return 'red'
      if(this.ext==='png' || this.ext==='jpg' || this.ext==='jpeg') return 'teal'
      return 'grey'
    },
    isMobile(){ return /iPhone|Android.+Mobile/.test(navigator.userAgent) },
    previewUrls(){
      try {
        return (this.files||[]).map(f => (f instanceof File || f instanceof Blob) ? URL.createObjectURL(f) : null).filter(Boolean)
      } catch(e){ console.warn('preview url error', e); return [] }
    }
  },

  data(){
    return {
      // PDF管理
      pdfToken: '',
      pdfPages: 0,
      pdfName: '',
      pdfPage: 1,

      // サムネ進捗
      thumbLoadedMap: {},
      thumbLoaded: 0,

      // サムネ失敗
      thumbErrorMap: {},

      // プレビュー
      currentPreviewSrc: '',
      previewLoading: false,
      previewError: '',
      previewKey: 0,

      // 状態
      stage: 'idle',        // idle | upload | open | warm | ready
      pdfOpening: false,
      pdfExporting: false,

      // エラー
      pdfError: '',
      openAbort: null,

      zahyokeiItems: [
        'WGS84',
        '公共座標1系', '公共座標2系', '公共座標3系',
        '公共座標4系', '公共座標5系', '公共座標6系',
        '公共座標7系', '公共座標8系', '公共座標9系',
        '公共座標10系', '公共座標11系', '公共座標12系',
        '公共座標13系', '公共座標14系', '公共座標15系',
        '公共座標16系', '公共座標17系', '公共座標18系',
        '公共座標19系',
        '日本測地系1系', '日本測地系2系', '日本測地系3系',
        '日本測地系4系', '日本測地系5系', '日本測地系6系',
        '日本測地系7系', '日本測地系8系', '日本測地系9系',
        '日本測地系10系', '日本測地系11系', '日本測地系12系',
        '日本測地系13系', '日本測地系14系', '日本測地系15系',
        '日本測地系16系', '日本測地系17系', '日本測地系18系',
        '日本測地系19系'
      ],
      transparentItems: [
        { label: '透過する。（処理遅い）', value: '1' },
        { label: '透過なし。（処理早い）', value: '0' }
      ],
    }
  },

  watch:{
    s_fileDialogOpen(v){
      if(v && this.ext==='pdf' && this.files.length) this.openOnServer(true)
      if(!v) this.resetServerState()
    },
    files(){
      this.resetServerState()
      if(this.ext==='pdf' && this.s_fileDialogOpen && this.files.length) this.openOnServer(true)
    },
    pdfPage(v){
      if(!this.pdfToken) return
      const n = Math.max(1, Math.min(this.pdfPages||1, Number(v||1)))
      if(n!==v) this.pdfPage = n
      this.loadPreview(n)
    }
  },

  methods:{
    onWatch() {
      this.$emit('watchPosition')
    },
    async toWarpWizard(useExport = true) {
      if (!this.pdfToken) return
      this.previewLoading = true
      const page = this.pdfPage || 1
      const action = useExport ? 'export' : 'preview' // export=高解像度, preview=中解像度
      const qp = new URLSearchParams({ action, token: this.pdfToken, page: String(page) })
      const url = `${APIBASE}?${qp.toString()}`
      try {
        const res = await fetch(url, { cache: 'no-store' })
        if (!res.ok) throw new Error(`fetch failed: ${res.status}`)
        const blob = await res.blob()
        // Blob -> File（ファイル名を生成）
        const fileName = `${(this.pdfName || 'document')}-p${page}.jpg`
        const fileObj = new File([blob], fileName, { type: 'image/jpeg' })
        this.$store.state.gazoName = fileName.replace(/\.jpg$/i, '')
        this.$store.state.pendingFile = fileObj
        this.s_fileDialogOpen = false
        this.$store.dispatch('showFloatingWindow', 'warp-wizard');
      } catch (e) {
        console.error('importJpegFromServer error:', e)
      } finally {
        this.previewLoading = false
      }
    },
    appUpdate() {
      location.reload(true)
      this.s_dialogForVersion = false
    },
    // async appUpdate(){
    //   this.s_versionMessage = false
    //
    //   // Service Workerの全キャッシュをクリア
    //   if ('caches' in window) {
    //     try {
    //       const cacheNames = await caches.keys()
    //       await Promise.all(cacheNames.map(name => caches.delete(name)))
    //     } catch (e) {
    //       console.error('[OH3] Failed to clear caches:', e)
    //     }
    //   }
    //
    //   // LocalStorageの選択的クリア（リセットボタンと同じロジック）
    //   // ユーザー設定（isPitch, mapillary等）やログイン情報は保持
    //   try {
    //     const keysToRemove = []
    //     for (let i = 0; i < localStorage.length; i++) {
    //       const key = localStorage.key(i)
    //       // skipフラグは保持する（無限ループ防止のため）
    //       if (key && (key.startsWith('fw:') || key.includes('cache') || key.includes('version')) && key !== 'oh3_skip_next_version_check') {
    //         keysToRemove.push(key)
    //       }
    //     }
    //     keysToRemove.forEach(key => localStorage.removeItem(key))
    //   } catch (e) {
    //     console.error('[OH3] Failed to clear localStorage:', e)
    //   }
    //
    //
    //   // Chrome iOSの無限ループ防止: 更新直後であることをマーク
    //   // 次回起動時のバージョンチェックを一時的にスキップする
    //   try {
    //     localStorage.setItem('oh3_skip_next_version_check', Date.now().toString())
    //   } catch (e) {
    //     console.warn('[OH3] Failed to set skip flag:', e)
    //   }
    //
    //   // タイムスタンプを追加してキャッシュバスティング & 強制リロード
    //   const baseUrl = `${window.location.origin}${window.location.pathname}`
    //   const timestamp = new Date().getTime()
    //   // ブラウザモード無限ループ防止: _just_updatedフラグを追加
    //   const urlWithTimestamp = `${baseUrl}?_nocache=${timestamp}&_just_updated=1`
    //
    //   // location.replaceでキャッシュを回避してリロード
    //   window.location.replace(urlWithTimestamp)
    // },
    resetServerState(){
      this.pdfToken = ''
      this.pdfPages = 0
      this.pdfName = ''
      this.pdfPage = 1
      this.thumbLoadedMap = {}
      this.thumbLoaded = 0
      this.thumbErrorMap = {}
      this.currentPreviewSrc = ''
      this.previewLoading = false
      this.previewError = ''
      this.pdfError = ''
      this.stage = 'idle'
      if(this.openAbort){ try{ this.openAbort.abort() }catch(e){} this.openAbort = null }
    },

    stepPage(delta){
      const next = Math.max(1, Math.min((this.pdfPages||Infinity), Number(this.pdfPage||1)+Number(delta||0)))
      this.pdfPage = next
    },
    selectPage(i){ this.pdfPage = i },

    async openOnServer(showSpinner=false){
      if(!this.files.length || this.ext!=='pdf') return
      const file = this.files[0]
      this.pdfError = ''
      this.previewError = ''

      if(showSpinner) this.previewLoading = true
      this.pdfOpening = true
      this.stage = 'upload'

      try{
        const fd = new FormData()
        fd.append('file', file, file.name || 'document.pdf')

        const ctrl = new AbortController()
        this.openAbort = ctrl

        const res = await fetch(`${APIBASE}?action=open`, { method:'POST', body:fd, signal:ctrl.signal })
        this.stage = 'open'
        if(!res.ok) throw new Error(await res.text().catch(()=> '') || `open failed: ${res.status}`)

        const json = await res.json()
        this.pdfToken = json.token
        this.pdfPages = json.pages
        this.pdfName = json.name
        this.pdfPage = 1
        this.thumbLoadedMap = {}
        this.thumbLoaded = 0
        this.thumbErrorMap = {}

        this.stage = 'warm'
        await this.loadPreview(1)
      }catch(e){
        if(e && e.name!=='AbortError') this.pdfError = String((e && e.message) || e)
        this.previewLoading = false
      }finally{
        this.pdfOpening = false
        this.openAbort = null
      }
    },

    thumbUrl(p){
      if(!this.pdfToken) return ''
      const qp = new URLSearchParams({ action:'thumb', token:this.pdfToken, page:String(p) })
      return `${APIBASE}?${qp.toString()}`
    },
    previewUrl(p){
      if(!this.pdfToken) return ''
      const qp = new URLSearchParams({ action:'preview', token:this.pdfToken, page:String(p) })
      return `${APIBASE}?${qp.toString()}`
    },

    onThumbLoad(p){
      if(this.thumbLoadedMap[p]) return
      this.thumbLoadedMap = { ...this.thumbLoadedMap, [p]: true }
      this.thumbLoaded = Object.keys(this.thumbLoadedMap).length
      if(this.thumbLoaded >= (this.pdfPages||0)) this.stage = 'ready'
    },
    onThumbError(p){
      this.thumbErrorMap = { ...this.thumbErrorMap, [p]: true }
      if(!this.thumbLoadedMap[p]){
        this.thumbLoadedMap = { ...this.thumbLoadedMap, [p]: true }
        this.thumbLoaded = Object.keys(this.thumbLoadedMap).length
      }
      if(this.thumbLoaded >= (this.pdfPages||0)) this.stage = 'ready'
    },

    async loadPreview(p){
      if(!this.pdfToken) return
      this.previewError = ''
      this.previewLoading = true

      const url = this.previewUrl(p)
      try{
        await new Promise((resolve, reject)=>{
          const img = new Image()
          img.onload = ()=> resolve(true)
          img.onerror = ()=> reject(new Error('preview load error'))
          img.src = url + (url.includes('?') ? '&' : '?') + 't=' + Date.now()
        })
        this.currentPreviewSrc = url
        this.previewKey++
        this.previewLoading = false
      }catch(e){
        this.previewLoading = false
      }
    },

    onPreviewLoad(){ this.previewLoading = false },
    onPreviewError(){ this.previewLoading = false },
    exportPage(p){
      if(!this.pdfToken) return
      const qp = new URLSearchParams({ action:'export', token:this.pdfToken, page:String(p) })
      window.open(`${APIBASE}?${qp.toString()}`, '_blank')
    },
  },

  mounted() {
    if (this.isAndroid) {
      this.stopOnMenu = (e) => {
        const content = e.target.closest('.v-overlay__content.scrollable-menu, .v-overlay__content .v-list, .v-select-list, .v-overlay__content');
        if (content) e.stopPropagation();
      };
      window.addEventListener('touchstart', this.stopOnMenu, { capture: true, passive: true });
      window.addEventListener('touchmove',  this.stopOnMenu, { capture: true, passive: true });
      window.addEventListener('touchend',   this.stopOnMenu, { capture: true, passive: true });
    }
  },
  unmounted() {
    if (this.isAndroid && this.stopOnMenu) {
      window.removeEventListener('touchstart', this.stopOnMenu, { capture: true });
      window.removeEventListener('touchmove',  this.stopOnMenu, { capture: true });
      window.removeEventListener('touchend',   this.stopOnMenu, { capture: true });
      this.stopOnMenu = null;
    }
  },
  beforeUnmount(){
    (this.previewUrls||[]).forEach(u=>{ try{ URL.revokeObjectURL(u) }catch(e){} })
    if(this.openAbort){ try{ this.openAbort.abort() }catch(e){} this.openAbort=null }
  }
}
</script>

<style scoped>
/* 進捗バー */
.statusBar{
  border:1px solid var(--v-theme-outline);
  background: linear-gradient(180deg, rgba(0,0,0,.02), rgba(0,0,0,0));
  border-radius: 10px;
  padding: 10px 12px
}
.statusText{ font-size:.9rem; margin-bottom:6px }

/* ヘッダーファイル名：1行省略 */
.ellipsis{
  max-width: 78vw;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis
}

/* ▼ ページ番号フィールド：低背＆小文字（約28px） */
.pageField :deep(.v-field){
  height: 28px
}
.pageField :deep(.v-field__input){
  padding-top: 0;
  padding-bottom: 0;
  font-size: .82rem;
  line-height: 1.2;
  margin-top: -5px;
}
.pageField :deep(.v-field__outline__start),
.pageField :deep(.v-field__outline__end){
  opacity: .9
}

/* プレビュー枠 */
.previewFrame{
  flex:1 1 auto;
  display:flex;
  flex-direction:column;
  border-radius:14px;
  border:1px solid rgba(0,0,0,.12);
  box-shadow: inset 0 0 0 1px rgba(255,255,255,.35), 0 6px 18px rgba(0,0,0,.06);
  overflow:hidden;
  background:#fff
}
.previewPane{
  position: relative;
  height: 60vh;
  max-height: 60vh;
  overflow: hidden;
  display:flex;
  align-items:center;
  justify-content:center;
  background: linear-gradient(180deg, rgba(0,0,0,0.02), rgba(0,0,0,0))
}
.previewPane::-webkit-scrollbar{ display:none }
.previewPane{ -ms-overflow-style:none; scrollbar-width:none }
.previewImg{
  display:block;
  max-width:100%;
  max-height:100%;
  width:auto;
  height:auto;
  object-fit:contain
}
.overlay{
  position:absolute;
  inset:0;
  display:flex;
  align-items:center;
  justify-content:center;
  background: rgba(0,0,0,0.06)
}

/* サムネ装飾 */
.thumbColumn{
  width: 280px;
  max-height: 60vh;
  overflow: auto;
  border: 1px solid var(--v-theme-outline);
  border-radius: var(--oh3-radius-xl);
  background: linear-gradient(180deg, rgba(0,0,0,.015), rgba(0,0,0,0))
}
.thumbGrid{
  display: grid;
  grid-template-columns: 1fr;
  gap: 10px;
  padding: 8px
}
.thumbCard{
  position: relative;
  border: 1px solid var(--v-theme-outline);
  border-radius: 10px;
  background: var(--oh3-color-white);
  box-shadow: 0 1px 1px rgba(0,0,0,.02), 0 2px 6px rgba(0,0,0,.04);
  overflow: hidden;
  cursor: pointer;
  transition: box-shadow .18s ease, transform .18s ease, border-color .18s ease
}
.thumbCard.isOdd{ border-color: rgba(0,128,255,.35) }
.thumbCard.isEven{ border-color: rgba(0,200,120,.35) }
.thumbCard:hover{ box-shadow: 0 4px 12px rgba(0,0,0,.08); transform: translateY(-1px) }
.thumbCard.active{ border-color: var(--v-theme-primary); box-shadow: 0 6px 16px rgba(0,0,0,.12) }
.thumbAccent{ position:absolute; left:0; top:0; bottom:0; width:4px; background: var(--v-theme-primary) }
.thumbBadge{
  position: absolute;
  top: 6px;
  left: 8px;
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 2px 6px;
  font-size: var(--oh3-font-size-sm);
  line-height: 1;
  border-radius: var(--oh3-radius-full);
  color: #0a0a0a;
  background: rgba(255,255,255,.92);
  box-shadow: 0 1px 3px rgba(0,0,0,.08);
  z-index: 2
}
.thumbImg{ display:block; width:100%; height:auto; object-fit:contain; background:#f7f7f8 }
.thumbHover{
  position:absolute; right:6px; top:6px; display:flex; gap:4px;
  opacity:0; transform:translateY(-2px); transition:all .15s ease; z-index:3
}
.thumbCard:hover .thumbHover{ opacity:1; transform:translateY(0) }

/* Component-specific styles using design system variables */
.v-dialog-common-warning-text {
  color: darkred;
}

.v-dialog-common-gap-8 {
  gap: var(--oh3-spacing-2);
}

.v-dialog-common-gap-10 {
  gap: 10px;
}

.v-dialog-common-gap-12 {
  gap: var(--oh3-spacing-3);
}

.v-dialog-common-gap-16 {
  gap: var(--oh3-spacing-4);
}

.v-dialog-common-page-field {
  width: 60px;
  margin-top: -5px;
}

.v-dialog-common-image-wrapper {
  width: min(320px, 100%);
  border: 1px solid var(--v-theme-outline);
}

.v-dialog-common-image-preview {
  display: block;
  width: 100%;
  height: auto;
  object-fit: contain;
}
</style>
